import {gsap} from 'gsap';
( function( app ) {
  const COMPONENT = {
    init: function() {
      document.querySelectorAll( '[data-component="benefits"]' ).forEach( ( component ) => {
        const pattern = component.querySelector( '.benefits__pattern-motion' );
        const contentAnimations = [...component.querySelectorAll( '.js-fade-group' )];

        if ( !pattern ) {
          return;
        }

        if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
          gsap.set( pattern, {autoAlpha: 1, y: 0} );
          return;
        }

        gsap.set( pattern, {autoAlpha: 0, y: -75} );

        const mutationObserver = new MutationObserver( () => revealPattern() );
        const revealPattern = () => {
          const contentIsAnimated = contentAnimations.every( ( element ) => element.classList.contains( 'js-animated' ) );

          if ( !contentIsAnimated ) {
            return;
          }

          mutationObserver.disconnect();
          gsap.to( pattern, {
            autoAlpha: 1,
            y: 0,
            duration: 0.75,
            delay: 1,
            ease: 'power2.out',
            clearProps: 'transform,visibility',
          } );
        };

        contentAnimations.forEach( ( element ) => {
          mutationObserver.observe( element, {attributes: true, attributeFilter: ['class']} );
        } );
        revealPattern();
      } );
    },
    finalize: function() {
    },
  };
  app.registerComponent( 'benefits', COMPONENT );
} )( app );
